<template>
  <div class="container">
    <h2 class="section-title">联系我们</h2>
    <p class="section-sub">专业团队为您提供智慧手术室解决方案咨询</p>
    <div class="two-col">
      <div class="contact-info">
        <div class="contact-item">📞 服务热线：<strong>xxx-xxx-xxxx</strong></div>
        <div class="contact-item">📧 电子邮箱：<strong>contact@aipuletech.com</strong></div>
        <div class="contact-item">📍 公司地址：<strong>苏州工业园区新发路27号C幢5楼</strong></div>
        <div class="contact-item">🕒 工作时间：周一至周五 9:00 - 18:00</div>
        <div class="btn-wrapper"><router-link to="/products" class="btn-primary">获取产品资料</router-link></div>
      </div>
      <div class="map-container">
        <div class="map-wrapper">
          <!-- 使用OpenStreetMap静态地图，无需API密钥 -->
          <img 
            src="/img/map.png"
            alt="爱谱乐医疗公司位置 - 苏州工业园区新发路27号C幢5楼"
            class="static-map"
            onerror="this.onerror=null;this.src='https://images.unsplash.com/photo-1542744095-291d1f67b221?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&h=400&q=80'"
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    openBaiduMap() {
      // 打开百度地图网页版
      window.open('https://map.baidu.com/search/苏州工业园区新发路27号C幢5楼', '_blank');
    }
  }
}
</script>

<style scoped>
.container { max-width: 1280px; margin: 0 auto; padding: 48px 24px; }
.section-title { font-size: 32px; font-weight: 700; text-align: center; margin-bottom: 16px; color: #0f2b36; }
.section-sub { text-align: center; color: #4b5563; max-width: 700px; margin: 0 auto 40px; }
.two-col { display: flex; gap: 32px; flex-wrap: wrap; }
.two-col > div { flex: 1; }
.contact-info { background: white; border-radius: 32px; padding: 40px; box-shadow: 0 8px 20px rgba(0,0,0,0.05); }
.contact-item { margin: 24px 0; display: flex; align-items: center; gap: 16px; font-size: 18px; }
.btn-wrapper { margin-top: 32px; }
.map-container { display: flex; flex-direction: column; }
.map-wrapper { 
  height: 400px; 
  border-radius: 32px; 
  overflow: hidden; 
  box-shadow: 0 12px 20px rgba(0,0,0,0.1);
}
.static-map {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 32px;
}
.btn-primary { background-color: #1f8aad; color: white; padding: 10px 24px; border-radius: 40px; text-decoration: none; display: inline-block; }
</style>